<template>
    <div
        v-if="origin"
        style="text-align: center;"
    >
        <i
            class="fa fa-image"
            style="font-size: 30px;"
        />
    </div>
    <div
        v-else
        ref="container"
        :style="data.style"
        @mousedown="triggerFocus($event, data.id)"
    >
        <table
            v-if="data.image && !isEdited"
            style="display: inline-table; vertical-align: top; width: 100%; height: 100%; border-spacing: 0px; border-collapse: collapse;"
            cellspacing="0"
            cellpadding="0"
            border="0"
        >
            <tbody>
                <tr>
                    <td style="vertical-align:top; width: 100%;">
                        <a
                            v-if="data.href"
                            target="_blank"
                            :data-blockid="data.id"
                            :href="data.href"
                            @click.prevent=""
                        >
                            <img
                                class="preview"
                                :alt="data.alt"
                                :src="data.thumbnail"
                                style="max-width: 100%; width: 100%;"
                            >
                        </a>
                        <img
                            v-else
                            class="preview"
                            :alt="data.alt"
                            :src="data.thumbnail"
                            style="max-width: 100%; width: 100%;"
                        >
                    </td>
                </tr>
            </tbody>
        </table>
        <div
            v-else-if="!isEdited"
            class="croppa-placeholder"
            :style="{width: '100%', height: h+'px'}"
        >
            <p><span class="fa fa-image" /></p>
        </div>
        <div
            v-else
            class="image-upload"
            style="text-align: center;"
        >
            <croppa
                v-model="imageData"
                accept="image/*"
                initial-size="cover"
                placeholder="Выберите изображение"
                placeholder-color="#606060"

                :initial-image="image"
                :width="w"
                :height="h"
                :canvas-color="'transparent'"
                :file-size-limit="maxSize"
                :disabled="false"
                :disable-click-to-choose="true"
                :disable-drag-and-drop="false"
                :disable-drag-to-move="false"
                :disable-scroll-to-zoom="false"
                :disable-pinch-to-zoom="true"
                :disable-rotation="false"
                :placeholder-font-size="0"
                :prevent-white-space="true"
                :auto-sizing="false"
                :zoom-speed="3"
                :show-remove-button="false"
                :quality="2"

                @file-type-mismatch="fileTypeMismatchMessage"
                @file-size-exceed="fileSizeExceededMessage"
                @new-image="saveOriginalImage"
                @init="restoreImageMetadata"
                @initial-image-loaded="restoreImageMetadata"
                @click="enterEditMode"
                @draw="fixCanvas"
            />
        </div>
        <blockparams
            v-if="isEdited" 
            v-bind="{data: data, type: 'image', container: $el, image: imageData, ih: h}"
            @imagechosen="setImage"
            @height-changed="setHeight"
            @height-auto="setHeightAuto"
            @update="update"
        />
        <div
            v-if="isEdited || isForced"
            class="vertical-resize-handle"
            @mousedown="resizeStart"
        >
            <span class="fa fa-ellipsis-h" />
        </div>
        <block-styles 
            v-if="(isEdited)" 
            :data="data"
            :wrapper="$refs.contentWrapper"
            @change="updateStyles" 
        />
    </div>
</template>

<script>
    import ComponentMixin from './Component.vue'
    import BlockStyles from './BlockStyles.vue'

    export default {
        name: 'Picture', 
        components: {'block-styles': BlockStyles},
        mixins: [ComponentMixin],
        props: {
            'bindedStyles': {
                type: Array,
                default: function () { return [
                    'borderRadius', 'backgroundColor', 'borderStyle', 'borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderColor', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight',
                ] }
            },
            maxSize: {
                type: Number,
                default: 4*1024*1024
            },
            metadata: {
                type: Object,
                default: null,
            }
        },
        data: function(){
            return {
                imageData: null,
                h: this.data.height || 200,
                w: null,
                changed: false,
                originChanged: false,
                resizeStartHeight: null,
                resizeStartPos: null,
                image: this.data.image
            }
        },
        watch: {
            h: function(val) {
                //if (val) {
                    //this.w = this.$parent.$el.offsetWidth; 
                    //if (this.data.hasOwnProperty('metadata')) {
                        //this.imageData.applyMetadata(JSON.parse(this.data.metadata));
                    //}
                //}
            },
            isEdited: function(val, newval) {
                let realH = this.$el.clientHeight; 

                if (this.data.style) {
                    for (let attr of ['paddingTop', 'paddingBottom']) {
                        if (this.data.style[attr]) {
                            realH -= parseInt(this.data.style[attr]); 
                        }

                    }
                }

                if (realH != this.h && this.data.metadata) {
                    let metadata = JSON.parse(this.data.metadata); 
                    let ratio = realH/this.h; 
                    this.h = realH;
                    metadata.scale = metadata.scale*ratio; 
                    metadata.startX = metadata.startX*ratio;
                    metadata.startY = metadata.startY*ratio;
                    this.$emit('update', this.data.id, {
                        metadata: JSON.stringify(metadata)
                    });
                }

                this.computeWidth();
            }
        },
        mounted: function() {
            this.computeWidth();
        },
        methods:{
            computeWidth: function() {
                let width = this.$parent.$el.offsetWidth;
                if (this.data.style) {
                    for (let attr of ['paddingLeft', 'paddingRight', 'borderRightWidth', 'borderLeftWidth']) {
                        if (this.data.style[attr]) {
                            width -= parseInt(this.data.style[attr]); 
                        }

                    }
                }
                this.w = width;
                console.log(width);
            },
            disableSelect: function(e) {
                e.preventDefault();
            },
            fixCanvas: function(e) {
                const canvas = this.imageData.getCanvas();
                canvas.style.height = 'auto';
                canvas.style.width = '100%';
            },
            resizeStart: function(e) {
                this.resizeStartPos = e.clientY;
                this.resizeStartHeight = this.h;
                document.addEventListener('mousemove', this.resize, true);
                document.addEventListener('mouseup', this.resizeStop, true);
                window.addEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'row-resize';
            },
            resizeStop: function(e) {
                this.resizeStartPos = null;
                document.removeEventListener('mousemove', this.resize, true);
                document.removeEventListener('mouseup', this.resizeStop, true);
                window.removeEventListener('selectstart', this.disableSelect);
                document.body.style.cursor = 'auto';
            },
            resize: function(e) {
                let delta = e.clientY - this.resizeStartPos ;

                this.h = this.resizeStartHeight + delta;
                if (this.h < 5) this.h = 5;

                this.$emit('update', this.data.id, {
                    'height': this.h,
                });
            },
            setImage: function(id, url) {
                this.originChanged = true;

                this.image = url;
                this.imageData.refresh();

                this.$emit('update', this.data.id, {
                    'image': url,
                    'imageid': id,
                    'height': this.h,
                });

                this.imageData.scaleRatio = 1;
            },
            fileTypeMismatchMessage: function() {
                alert('Неподдерживаемый тип файла');
            },
            fileSizeExceededMessage: function() {
                alert('Размер файла не должен превышать '+this.maxSize+' байт');
            },
            saveOriginalImage: function() {
                let url = '/upload/'; 
                let component = this;
                this.$root.lock();

                this.setHeightAuto();

                let postdata = {
                    file: this.imageData.originalImage.src
                }

                if (component.$root.siteId) {
                    url = '/upload/' + component.$root.siteId + '/';
                }

                $.post(url, postdata, function(originres) {
                    if (originres.status === 'error') {
                        alert(originres.msg);
                        return;
                    }
                    component.setImage(originres.id, originres.url);

                }).fail(function() {
                    alert( "Ошибка при сохранении оригинала изображения" );
                }).always(function( data ) {
                    component.$root.unlock();
                });;
            },
            restoreImageMetadata: function() {

                if (!this.imageData || !this.imageData.originalImage) {
                    return
                }

                if (this.originChanged) {
                    this.setHeightAuto();
                    this.imageData.scaleRatio = 1;
                    this.originChanged = false;

                    this.$emit('update', this.data.id, {
                        'metadata': JSON.stringify(this.imageData.getMetadata()),
                    });
                }

                if (this.data.metadata) {
                    this.imageData.applyMetadata(JSON.parse(this.data.metadata));
                }
            },
            setHeight: function(height) {
                this.h = height; 
                this.changed = true; 
            },
            setHeightAuto: function() {
                console.log('height auto');
                this.setHeight(
                    Math.round(this.imageData.originalImage.height*(this.w/this.imageData.originalImage.width))
                );
            },
            hasChanged: function() {
                if (!this.data.hasOwnProperty('metadata')) {
                    return true;
                }
                const keys = ['startX', 'startY', 'scale', 'orientation'];
                const stored = JSON.parse(this.data.metadata);
                const current = this.imageData.getMetadata();
                for (let i in keys) {
                    if (stored[keys[i]] != current[keys[i]]) {
                        return true;
                    }
                }
                return false;
            },
            updateStyles: function(data) {
                this.update(this.data.id, {'style': data});
                this.computeWidth();
                this.$forceUpdate();
            },

            dragstart: function(id, name, event) {
                console.log(id);
                this.$emit('dragstart', id, name, event);
            },
            dragend: function(event) {
                console.log(event);
                this.$emit('dragend', event);
            },
            leaveEditMode: function(event) {
                if (this.$el.contains(event.target)) {
                    return;
                }

                if (!this.$root.$el.contains(event.target)) {
                    return;
                }

                let component = this;

                this.$emit('update', this.data.id, {
                    'height': component.h 
                });

                if (this.imageData && this.imageData.hasImage() && (this.hasChanged() || this.changed)) {
                    let mime = 'image/jpeg';
                    let url = '/upload/';

                    this.$root.lock();
                    this.changed = false; 

                    let postdata = {
                        meta: JSON.stringify(component.imageData.getMetadata()), 
                        origin_id: this.data.imageid
                    };

                    let ext = component.imageData.originalImage.src.split(';')[0]

                    if (ext.includes('png')){
                        mime = 'image/png'; 
                    } else if (ext.includes('gif')) {
                        mime = 'image/png'; 
                    }

                    postdata['file'] = this.imageData.generateDataUrl(mime, 0.9);

                    if (component.$root.siteId) {
                        url = '/upload/' + component.$root.siteId + '/';
                    }

                    $.post(url, postdata, function(thumbres) {
                        if (thumbres.status === 'error') {
                            alert(thumbres.msg);
                        }
                        component.$emit('update', component.data.id, {
                            'thumbnail': thumbres.url,
                            'metadata': JSON.stringify(component.imageData.getMetadata())
                        });
                        component.unfocus(this.data.id, event);
                        component.$root.unlock();
                    }).fail(function() {
                        alert( "Ошибка при загрузке изображения" );
                    }).always(function( data ) {
                        component.isEdited = false;
                        document.removeEventListener('mousedown', component.leaveEditMode, true);
                        component.unfocus(this.data.id, event);
                        component.$root.unlock();
                    });;
                } else {
                    component.isEdited = false;
                    document.removeEventListener('mousedown', component.leaveEditMode, true);
                    component.unfocus(this.data.id, event);
                }
            },
        }
    }
</script>
